<template>
    <div class="portfolio-container">
        <div class="dialog-window">
            <!-- Title Bar -->
            <div class="dialog-titlebar">
                <span class="dialog-title">10-4</span>
            </div>

            <!-- Content with icon and message -->
            <div class="dialog-content">
                <div class="dialog-icon">
                    <span class="icon-text">?</span>
                </div>
                <div class="dialog-message">
                    <p class="description">Envie de découvrir des expériences web créatives qui captivent et engagent ?
                        Explorez des projets conçus avec passion par des créateurs québécois.</p>
                </div>
            </div>

            <!-- Buttons -->
            <div class="dialog-buttons">
                <button class="btn-dialog btn-primary" @click="navigateToProjects">
                    Oui
                </button>
                <button class="btn-dialog btn-secondary" @click="handleSecondButton">
                    {{ secondButtonText }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PortfolioLandingPage',
    data() {
        return {
            secondButtonClicked: false
        }
    },
    computed: {
        secondButtonText() {
            return this.secondButtonClicked ? 'Bien sûr' : 'Non';
        }
    },
    methods: {
        navigateToProjects() {
            this.$router.push('/projets');
        },
        handleSecondButton() {
            if (this.secondButtonClicked) {
                this.$router.push('/projets');
            } else {
                this.secondButtonClicked = true;
            }
        }
    }
}
</script>

<style scoped>
.portfolio-container {
    min-height: calc(100vh - var(--header-height));
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(to bottom, #d4e7f7 0%, #ffffff 50%, #f0f0f0 100%);
}

/* Windows 7 Dialog Window */
.dialog-window {
    width: 100%;
    max-width: 500px;
    background: #f0f0f0;
    border: 1px solid #0078d7;
    border-radius: 8px 8px 0 0;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3), 0 2px 8px rgba(0, 0, 0, 0.2);
    overflow: hidden;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

/* Title Bar */
.dialog-titlebar {
    background: linear-gradient(to bottom, #5cb3f9 0%, #3b8dd2 50%, #2978b9 100%);
    padding: 8px 12px;
    border-bottom: 1px solid #1e5c99;
    display: flex;
    align-items: center;
}

.dialog-title {
    font-family: 'Orbitron', 'Impact', 'Arial Black', sans-serif;
    font-size: 1.2rem;
    font-weight: 700;
    color: #ffffff;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
    letter-spacing: 0.05em;
}

/* Content Area */
.dialog-content {
    display: flex;
    gap: 20px;
    padding: 24px;
    background: linear-gradient(to bottom, #ffffff 0%, #f7f7f7 100%);
    align-items: flex-start;
}

.dialog-icon {
    flex-shrink: 0;
    width: 48px;
    height: 48px;
    background: linear-gradient(135deg, #5cb3f9 0%, #2978b9 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.icon-text {
    font-size: 32px;
    font-weight: bold;
    color: #ffffff;
    line-height: 1;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
}

.dialog-message {
    flex: 1;
}

.description {
    font-size: 1rem;
    line-height: 1.6;
    margin: 0;
    color: #1a1a1a;
    text-align: left;
}

/* Buttons Area */
.dialog-buttons {
    display: flex;
    gap: 8px;
    justify-content: flex-end;
    padding: 12px 16px;
    background: #f0f0f0;
    border-top: 1px solid #dfdfdf;
}

.btn-dialog {
    min-width: 80px;
    height: 24px;
    padding: 0 16px;
    font-size: 0.9rem;
    font-weight: 400;
    cursor: pointer;
    transition: all 0.1s ease;
    border-radius: 3px;
    font-family: 'Segoe UI', Tahoma, sans-serif;
}

.btn-primary {
    background: linear-gradient(to bottom, #5cb3f9 0%, #3b8dd2 50%, #2978b9 100%);
    color: white;
    border: 1px solid #2978b9;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.4), 0 1px 2px rgba(0, 0, 0, 0.2);
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);
}

.btn-primary:hover {
    background: linear-gradient(to bottom, #6ec0ff 0%, #4a9de6 50%, #3388cc 100%);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.5), 0 1px 3px rgba(0, 0, 0, 0.25);
}

.btn-primary:active {
    background: linear-gradient(to bottom, #3388cc 0%, #2978b9 50%, #1e6ba8 100%);
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.2);
}

.btn-secondary {
    background: linear-gradient(to bottom, #fbfbfb 0%, #ebebeb 50%, #dddddd 100%);
    color: #1a1a1a;
    border: 1px solid #abadb3;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8), 0 1px 2px rgba(0, 0, 0, 0.1);
}

.btn-secondary:hover {
    background: linear-gradient(to bottom, #ffffff 0%, #f0f0f0 50%, #e5e5e5 100%);
    border-color: #7a7d85;
}

.btn-secondary:active {
    background: linear-gradient(to bottom, #d5d5d5 0%, #e0e0e0 100%);
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.15);
}

/* Windows 7 blue selection for portfolio */
.portfolio-container ::-moz-selection {
    background-color: #0078d7;
    color: #fff;
}

.portfolio-container ::selection {
    background-color: #0078d7;
    color: #fff;
}

/* Responsive */
@media (max-width: 768px) {
    .portfolio-container {
        padding: 0px;
    }

    .dialog-window {
        max-width: calc(100% - 1rem);
        margin: 0 1.5rem;
    }

    .dialog-content {
        flex-direction: column;
        align-items: center;
        text-align: center;
    }

    .dialog-icon {
        margin-bottom: 12px;
    }

    .description {
        text-align: center;
        font-size: 0.95rem;
    }

    .dialog-buttons {
        justify-content: center;
    }
}
</style>
